


























import {
    defineComponent,
    PropType,
    nextTick,
    ref,
    onUpdated,
    onMounted,
} from "@nuxtjs/composition-api";
import { storeToRefs } from "pinia";
import { useCart } from "@wemade-vsf/customer";
import { useImage } from "@wemade-vsf/composables";
import { usePageStore } from "@wemade-vsf/core";
import { useScrollPositionStore } from "~/stores/scrollPosition";
import ProductCardHorizontal from "components/catalog/Product/ProductCardHorizontal.vue";
import SkeletonLoader from "components/theme/SkeletonLoader.vue";
import type { Product } from "@wemade-vsf/catalog/lib/runtime/product/types";
import useDeliverySwatchData from "~/composables/useDeliverySwatchData";

export default defineComponent({
    components: {
        ProductCardHorizontal,
        SkeletonLoader,
    },
    props: {
        products: {
            type: Array as PropType<Product[]>,
            required: true,
        },
        pricesLoaded: Boolean,
        loading: Boolean,
    },
    emits: ["click:wishlist", "click:add-to-cart"],
    setup() {
        const {
            imageSizes: { productCard: imageSize },
        } = useImage();
        const { routeData } = usePageStore();
        const scrollPositionStore = useScrollPositionStore();
        const { lastRoute } = storeToRefs(scrollPositionStore);
        const scrolled = ref(false);

        const scrollToPosition = () => {
            if (!process.browser || scrolled.value) return;
            if (lastRoute.value === routeData.uid) {
                const scroll = scrollPositionStore.getScrollPosition(
                    routeData.uid
                );
                window.scrollTo(0, scroll);
            }
            scrolled.value = true;
            lastRoute.value = routeData.uid;
        };

        function storeScrollPosition() {
            scrollPositionStore.setScrollPosition(
                routeData.uid,
                window.scrollY
            );
        }

        onUpdated(() => {
            nextTick(() => {
                scrollToPosition();
                const footer = document.getElementById("app-footer-container");
                const distance =
                    document.documentElement.clientHeight -
                    footer.getBoundingClientRect().top;
                document.documentElement.style.setProperty(
                    "--site-footer",
                    `${distance < 0 ? "0" : distance}px`
                );
            });
        });

        const { cart, load: loadCart } = useCart();
        onMounted(async () => {
            if (!cart.value || !cart.value.id) {
                await loadCart();
            }
        });

        const { load: loadSwatchData, deliverySwatchData } =
            useDeliverySwatchData();

        if (!deliverySwatchData.value) {
            loadSwatchData();
        }

        return {
            imageSize,
            storeScrollPosition,
            cart,
            deliverySwatchData,
        };
    },
});
